module.exports = __webpack_public_path__ + "static/media/DC_O_Timeless_Sforza_Orange.439cde69.png";